const React = require('react');
const MobileMenu = require('../../MobileMenu');
const DesktopMenu = require('../../DesktopMenu');
const Search = require('../../Search');
const RESPONSIVE_BREAK = 1024;
const isNode = (typeof process !== 'undefined');

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: null,
            searchOpen: false
        };
        this.setWidth = this.setWidth.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.setWidth);
        window.addEventListener('keyup', this.handleEscape);
        this.setWidth();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setWidth);
        window.removeEventListener('keyup', this.handleEscape);
    }

    setWidth() {
        this.setState({
            width: window.innerWidth
        });
    }

    handleEscape(e) {
        if (e.keyCode === 27) {
            this.setState({ searchOpen: false });
        }
    }

    toggleSearch() {
        const { searchOpen } = this.state;
        this.setState({ searchOpen: !searchOpen });
    }

    render() {
        const { width, searchOpen } = this.state;
        return (
        <header className="header" ref="header">
            {(width > RESPONSIVE_BREAK) ? <DesktopMenu {...this.props} toggleSearch={this.toggleSearch}/> : <MobileMenu {...this.props} toggleSearch={this.toggleSearch}/>}
            {searchOpen && <Search searchPage={this.props.searchPage} toggleSearch={this.toggleSearch} />}
        </header>
        )
    }
}

module.exports = Header;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/header/Component/index.jsx